var _path;
import * as React from "react";
function SvgArrowCircleRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4c8.839 0 16 7.161 16 16s-7.161 16-16 16S4 28.839 4 20 11.161 4 20 4zm-1.864 9.264l4.87 4.672h-11.78c-.858 0-1.549.69-1.549 1.548v1.032c0 .858.69 1.549 1.549 1.549h11.78l-4.87 4.67a1.55 1.55 0 00-.026 2.213l.71.704a1.542 1.542 0 002.186 0l8.562-8.555a1.542 1.542 0 000-2.187l-8.562-8.568a1.542 1.542 0 00-2.187 0l-.71.703c-.612.62-.6 1.62.026 2.22z"
  })));
}
export default SvgArrowCircleRight;